export default {
  TRACK_EVENT: 'TRACK_EVENT',
  TRACK_FLUSH: 'TRACK_FLUSH',
  TRACK_AB_TEST: 'TRACK_AB_TEST',
  TRACK_ESCROW_USER_ACTION: 'TRACK_ESCROW_USER_ACTION',
  GET_AB_TEST: 'TRACKING.GET_AB_TEST',
  TRACK_FORM_SUBMISSION_BY_NAME: 'TRACK_FORM_SUBMISSION_BY_NAME',
  TRACK_FORM_SUBMISSION_FAIL_BY_NAME: 'TRACK_FORM_SUBMISSION_FAIL_BY_NAME',
};
